// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import notification from 'antd/lib/notification';
import styled from 'styled-components';
import { addMdmNode, cleanMdmNode, fetchMdmNode, updateMdmNode } from '../../ducks/mdmNode';
import { Header, Panel } from '../../components/layout';
import Breadcrumbs, { Crumb } from '../../components/layout/Breadcrumbs';
import InnerForm from './components/InnerForm';
import { goBack } from './../../lib/helpers';
import { notificationLoading } from './../../components/Notifications';
const StyledPanel = styled(Panel).withConfig({
  displayName: "MdmForm__StyledPanel",
  componentId: "sc-19xmoxe-0"
})(["padding-top:0;"]);
export class MdmForm extends React.Component {
  async componentDidMount() {
    const {
      mdmGuid
    } = this.props;
    await this.props.cleanMdmNode();
    try {
      if (mdmGuid) {
        await this.props.fetchMdmNode(mdmGuid);
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  }
  handleSubmit = async values => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      if (this.props.mdmGuid) {
        await this.props.updateMdmNode(values);
        notification.success({
          message: 'Успешное обновление',
          description: 'Запись успешно обновлена'
        });
      } else {
        await this.props.addMdmNode(values);
        notification.success({
          message: 'Успешное создание',
          description: 'Запись успешно создана'
        });
      }
      this.handleBack();
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };
  handleBack = () => goBack('/admin/mdm');
  render() {
    const {
      mdmGuid,
      mdmNode
    } = this.props;
    if (!mdmNode) return null;
    return <>
        <Header left={<Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/admin/mdm">МТРиО</Crumb>
              {mdmGuid ? <Crumb>{mdmNode.payload.name}</Crumb> : <Crumb>Новая запись МТРиО</Crumb>}
            </Breadcrumbs>} />
        <StyledPanel>
          <h1>{mdmNode.name}</h1>
        </StyledPanel>
        <InnerForm mdmNode={mdmNode} onCancel={this.handleBack} onSubmit={this.handleSubmit} />
      </>;
  }
}
export default connect((state, props) => ({
  mdmNode: state.mdmNode
}), {
  fetchMdmNode,
  cleanMdmNode,
  updateMdmNode,
  addMdmNode
})(MdmForm);
